import * as oauth2 from 'oauth4webapi'

import { loadAuthData } from './authData'
import { getClient, getServer } from './serverClient'
import { storeSession } from './session'
import { getLoginCallbackUrl } from './utils'
import { AuthSettings } from './types'

export const handleCallback = async (authSettings: AuthSettings) => {
    const { issuer, clientId } = authSettings
    const currentUrl = new URL(window.location.href)

    if (currentUrl.pathname !== '/auth/callback') {
        return
    }

    const state = currentUrl.searchParams.get('state')

    if (!state) {
        return
    }

    const authData = loadAuthData(state)
    if (!authData) {
        return null
    }

    const server = getServer(issuer)
    const client = getClient(clientId)

    const { codeVerifier, returnTo } = authData
    const params = oauth2.validateAuthResponse(server, client, currentUrl, state)

    if (oauth2.isOAuth2Error(params)) {
        console.log('error', params)
        return null
    }

    const response = await oauth2.authorizationCodeGrantRequest(
        server,
        client,
        params,
        getLoginCallbackUrl(authSettings),
        codeVerifier
    )

    const result = await oauth2.processAuthorizationCodeOpenIDResponse(server, client, response)
    if (oauth2.isOAuth2Error(result)) {
        console.log('error', result)
        return null
    }

    const { access_token, refresh_token, expires_in = 0, id_token } = result
    const [, idTokenDataEncoded] = id_token.split('.')
    const idTokenDataString = atob(idTokenDataEncoded)

    const idTokenData = JSON.parse(idTokenDataString)

    storeSession(authSettings, {
        userId: idTokenData.sub,
        idToken: id_token,
        accessToken: access_token,
        refreshToken: refresh_token,
        tokenExpiration: new Date(Date.now() + expires_in * 1000),
    })

    const normalizedReturnTo = (returnTo || '/').replaceAll('javascript:', '')

    window.location.replace(normalizedReturnTo)
}
